// Translations loader - merges all translation files at runtime
// Note: Previously used val-loader for compile-time merge, but that's incompatible with Node.js 24+

import globalTranslations from './translations/global'
import merge from 'lodash/merge'
import railsTranslations from './translations/rails'

const translations = merge({}, railsTranslations, globalTranslations)

window.translations = translations

export default translations
